// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  mode: 'local',
};
// export const NOTIFICATION_SOCKET_PORT = 'http://localhost:3100';
export const ns = '/customer';
// LOCALHOST
// export const domainRaw = 'http://192.168.29.27:6500';
// export const domainRaw = "http://localhost:6500";

// export const domainRaw = "https://apisi.labzeno.com";
export const domainRaw = "https://snatchit-api.qztbox.com";

export const currentVersion = '1';
export const domain = `${domainRaw}${ns}`;
// export const domain2 = `${domainRaw2}${ns}`;

// ionic capacitor build android
// ionic capacitor build ios
// ionic capacitor build android --no-open
// build.gradle for version control
// ionic capacitor add ios
// resources: cordova-res ios --skip-config --copy

// change apk logo
// Expand the project root folder in the Project View
// Right Click on the app folder
// In the Context Menu go to New->Image Asset
// In the pop up that appears select the the new logo you would like to have(image/clip art/text).
// If you were selecting the image radio button (as is the default choice), if you clicked on the 3-buttons
// to show the path tree to locate your .png image file, most probably you might not be seeing it,
// so drag it from the Windows Explorer (if Windows) and drop it in the tree,
// and it will appear and ready for being selected.

// ANDROID TARGET 31 > variables.gradle = set targetSdkVersion to 31 and in AndroidManifest.xml add android:exported="true" in activity tag

// FOR IOS if quote error
// pods > build setting > apple clang - warnings - all lang > quoted include in framework header = no

// push notification:: https://capacitorjs.com/docs/guides/push-notifications-firebase

// setup pushnotification properly
// https://github.com/capawesome-team/capacitor-firebase/blob/main/docs/firebase-setup.md
